// Final UI copy of the Assistant. All strings are English and hard-coded (no i18n).
export const COMPOSER_PLACEHOLDER = 'Ask anything about your work…';
export const COMPOSER_DISABLED_PLACEHOLDER =
  'Asking is turned off for your team';
export const DISCLAIMER =
  'AI can make mistakes. Check important info in the sources.';
export const SEARCHING = 'Searching your knowledge base…';
export const LOAD_EARLIER = 'Load earlier messages';

export const EMPTY_TITLE = 'Ask me anything';
export const EMPTY_TEXT =
  "I answer from your team's Resources, Training and Google Drive, and show where each answer comes from.";
export const SUGGESTED_QUESTIONS = [
  'How do I run a listing appointment?',
  "What's our buyer consultation checklist?",
  'Give me a follow-up script after an open house',
];

export const KIND_LABELS = {
  NOT_FOUND: 'Not in your knowledge base',
  DECLINED: 'Outside what I can help with',
} as const;

export const ERROR_TITLE = "Couldn't answer";
export const RETRY = 'Try again';

const GENERIC = 'Something went wrong. Try again.';
const ERRORS: Record<string, { message: string; retry: boolean }> = {
  MODEL_ERROR: {
    message: "I couldn't finish this answer. Try again.",
    retry: true,
  },
  MODEL_REFUSED: {
    message: "I couldn't answer this question. Try rephrasing it.",
    retry: false,
  },
  SEARCH_UNAVAILABLE: {
    message: 'Search is temporarily unavailable. Try again in a minute.',
    retry: true,
  },
  TIMEOUT: { message: 'This took too long. Try again.', retry: true },
  RUN_IN_PROGRESS: {
    message:
      "I'm still answering this question. Wait a moment, then send it again.",
    retry: false,
  },
  NETWORK: {
    message:
      "Couldn't reach the Assistant. Check your connection and try again.",
    retry: true,
  },
};

export const errorCopy = (code: string) =>
  ERRORS[code] ?? { message: GENERIC, retry: true };

export const SOURCES = 'Sources';
export const NO_LONGER_AVAILABLE = 'No longer available';
export const SOURCE_LABELS: Record<string, string> = {
  hub: 'Resources',
  lms: 'Training',
  drive: 'Google Drive',
};

export const MESSAGES_ERROR_TITLE = "Couldn't load this question";
export const MESSAGES_ERROR_TEXT = 'Check your connection and try again.';

export const INTERRUPTED_TITLE = 'Answer interrupted';
export const INTERRUPTED_TEXT =
  'The connection dropped before I finished. Try again.';
export const KNOWLEDGE_OFF_TITLE = 'Knowledge base is turned off';
export const KNOWLEDGE_OFF_TEXT =
  "Your team's knowledge base is off, so you can't ask new questions. Past questions stay available.";

export const HISTORY_HEADING = 'Question history';
export const NEW_QUESTION = 'New question';
export const SHOW_MORE = 'Show more';
export const HISTORY_EMPTY = 'Your questions will show up here.';
export const HISTORY_ERROR = "Couldn't load your questions";

export const QUESTION_ACTIONS = 'Question actions';
export const RENAME = 'Rename';
export const DELETE = 'Delete';
export const CANCEL = 'Cancel';
export const QUESTION_TITLE = 'Question title';
export const DELETE_TITLE = 'Delete question?';
export const deleteDescription = (title: string) =>
  `"${title}" and its answers will be permanently deleted.`;
export const RENAME_GONE = 'This question no longer exists';
export const RENAME_FAILED = "Couldn't rename the question. Try again.";
export const DELETE_FAILED = "Couldn't delete the question. Try again.";

export const ASSISTANT_TITLE = 'AI Assistant';
export const ASK_ME = 'Ask Me';
export const BACK_TO_APP = 'Back to app';
export const SEND = 'Send';
export const ASK_BAR_LABEL = 'Ask the AI Assistant';
export const THREAD_DELETED = 'This question was deleted';
export const HIDE_HISTORY = 'Hide question history';
export const SHOW_HISTORY = 'Show question history';
export const ASSISTANT_NAME = 'Assistant';
